// src/api/huella.js
import { apiFetch } from './index.js';

// ============================================================
// FUNCIONES PARA ASISTENCIA
// ============================================================

/**
 * Obtener asistencia del día
 * @returns {Promise} Registros de asistencia del día
 */
export const obtenerAsistenciaHoy = async () => {
  try {
    console.log('📊 Obteniendo asistencia de hoy...');
    const response = await apiFetch('/Huella/asistencia-hoy');
    console.log('✅ Asistencia obtenida:', response);
    return {
      success: true,
      data: response,
      message: 'Asistencia obtenida exitosamente'
    };
  } catch (error) {
    console.error('❌ Error obteniendo asistencia:', error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Obtener estadísticas de asistencia
 * @returns {Promise} Estadísticas
 */
export const obtenerEstadisticasAsistencia = async () => {
  try {
    console.log('📊 Obteniendo estadísticas de asistencia...');
    const response = await apiFetch('/Huella/estadisticas');
    console.log('✅ Estadísticas obtenidas:', response);
    return {
      success: true,
      data: response,
      message: 'Estadísticas obtenidas exitosamente'
    };
  } catch (error) {
    console.error('❌ Error obteniendo estadísticas:', error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Obtener estado del lector de huella
 * @returns {Promise} Estado del lector
 */
export const obtenerEstadoLector = async () => {
  try {
    console.log('🔍 Obteniendo estado del lector...');
    const response = await apiFetch('/Huella/estado');
    console.log('✅ Estado del lector:', response);
    return {
      success: true,
      data: response,
      message: 'Estado del lector obtenido'
    };
  } catch (error) {
    console.error('❌ Error obteniendo estado del lector:', error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

// ============================================================
// FUNCIONES PARA CONEXIÓN DEL LECTOR
// ============================================================

/**
 * 🔥 Conectar lector de huella (USB - sin puerto COM)
 * @returns {Promise} Resultado de la conexión
 */
export const conectarLector = async () => {
  try {
    console.log('🔌 Conectando lector USB...');
    const response = await apiFetch('/Huella/conectar', {
      method: 'POST',
      body: JSON.stringify({})
    });
    console.log('✅ Respuesta conexión:', response);
    return {
      success: true,
      data: response,
      message: response.mensaje || 'Lector conectado'
    };
  } catch (error) {
    console.error('❌ Error conectando lector:', error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Desconectar lector de huella
 * @returns {Promise} Resultado de la desconexión
 */
export const desconectarLector = async () => {
  try {
    console.log('🔌 Desconectando lector...');
    const response = await apiFetch('/Huella/desconectar', {
      method: 'POST'
    });
    console.log('✅ Respuesta desconexión:', response);
    return {
      success: true,
      data: response,
      message: response.mensaje || 'Lector desconectado'
    };
  } catch (error) {
    console.error('❌ Error desconectando lector:', error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

// ============================================================
// FUNCIONES PARA GESTIÓN DE HUELLAS
// ============================================================

/**
 * Obtener usuarios con huella registrada
 * @returns {Promise} Lista de usuarios
 */
export const obtenerUsuariosConHuella = async () => {
  try {
    console.log('👥 Obteniendo usuarios con huella...');
    const response = await apiFetch('/Huella/usuarios-con-huella');
    console.log('✅ Usuarios con huella obtenidos:', response.length || 0);
    return {
      success: true,
      data: response,
      message: 'Usuarios con huella obtenidos'
    };
  } catch (error) {
    console.error('❌ Error obteniendo usuarios con huella:', error);
    return {
      success: false,
      error: error.message,
      data: []
    };
  }
};

/**
 * Verificar si un usuario tiene huella registrada
 * @param {number} idUsuario - ID del usuario
 * @returns {Promise} Resultado
 */
export const usuarioTieneHuella = async (idUsuario) => {
  try {
    console.log(`🔍 Verificando huella del usuario ${idUsuario}...`);
    const response = await apiFetch(`/Huella/usuario-tiene-huella/${idUsuario}`);
    console.log('✅ Verificación completada:', response);
    return {
      success: true,
      data: response,
      message: 'Verificación completada'
    };
  } catch (error) {
    console.error(`❌ Error verificando huella del usuario ${idUsuario}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Registrar huella para un usuario
 * @param {number} idUsuario - ID del usuario
 * @param {string} templateData - Plantilla de la huella
 * @returns {Promise} Resultado
 */
export const registrarHuella = async (idUsuario, templateData) => {
  try {
    console.log(`📝 Registrando huella para usuario: ${idUsuario}`);
    const response = await apiFetch('/Huella/registrar-huella', {
      method: 'POST',
      body: JSON.stringify({
        idUsuario: idUsuario,
        templateData: templateData
      })
    });
    console.log('✅ Respuesta registro huella:', response);
    return {
      success: true,
      data: response,
      message: response.mensaje || 'Huella registrada'
    };
  } catch (error) {
    console.error(`❌ Error registrando huella para usuario ${idUsuario}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Eliminar huella de un usuario
 * @param {number} idUsuario - ID del usuario
 * @returns {Promise} Resultado
 */
export const eliminarHuella = async (idUsuario) => {
  try {
    console.log(`🗑️ Eliminando huella del usuario: ${idUsuario}`);
    const response = await apiFetch(`/Huella/eliminar-huella/${idUsuario}`, {
      method: 'DELETE'
    });
    console.log('✅ Respuesta eliminar huella:', response);
    return {
      success: true,
      data: response,
      message: response.mensaje || 'Huella eliminada'
    };
  } catch (error) {
    console.error(`❌ Error eliminando huella del usuario ${idUsuario}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Activar modo de registro de huella para un usuario
 * @param {number} idUsuario - ID del usuario
 * @returns {Promise} Resultado
 */
export const activarModoRegistro = async (idUsuario) => {
  try {
    console.log(`🔍 Activando modo registro para usuario: ${idUsuario}`);
    const response = await apiFetch('/Huella/activar-modo-registro', {
      method: 'POST',
      body: JSON.stringify({ idUsuario })
    });
    console.log('✅ Respuesta activar modo registro:', response);
    return {
      success: true,
      data: response,
      message: response.mensaje || 'Modo registro activado'
    };
  } catch (error) {
    console.error(`❌ Error activando modo registro para usuario ${idUsuario}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

// ============================================================
// FUNCIONES PARA REGISTRO DE ASISTENCIA
// ============================================================

/**
 * Registrar asistencia manualmente
 * @param {number} idUsuario - ID del usuario
 * @param {string} tipoRegistro - 'entrada' o 'salida'
 * @returns {Promise} Resultado
 */
export const registrarAsistenciaManual = async (idUsuario, tipoRegistro = 'entrada') => {
  try {
    console.log(`📝 Registro manual para usuario: ${idUsuario}, tipo: ${tipoRegistro}`);
    const response = await apiFetch('/Huella/registrar-manual', {
      method: 'POST',
      body: JSON.stringify({
        idUsuario: idUsuario,
        tipoRegistro: tipoRegistro
      })
    });
    console.log('✅ Respuesta registro manual:', response);
    return {
      success: true,
      data: response,
      message: response.mensaje || 'Registro manual completado'
    };
  } catch (error) {
    console.error(`❌ Error en registro manual para usuario ${idUsuario}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Obtener historial de asistencia de un usuario
 * @param {number} idUsuario - ID del usuario
 * @param {string} desde - Fecha inicio (YYYY-MM-DD)
 * @param {string} hasta - Fecha fin (YYYY-MM-DD)
 * @returns {Promise} Historial
 */
export const obtenerHistorialAsistencia = async (idUsuario, desde = null, hasta = null) => {
  try {
    let url = `/Huella/historial/${idUsuario}`;
    const params = [];
    if (desde) params.push(`desde=${desde}`);
    if (hasta) params.push(`hasta=${hasta}`);
    if (params.length > 0) url += `?${params.join('&')}`;
    
    console.log(`📋 Obteniendo historial del usuario ${idUsuario}...`);
    const response = await apiFetch(url);
    console.log('✅ Historial obtenido:', response.length || 0);
    return {
      success: true,
      data: response,
      message: 'Historial obtenido'
    };
  } catch (error) {
    console.error(`❌ Error obteniendo historial del usuario ${idUsuario}:`, error);
    return {
      success: false,
      error: error.message,
      data: []
    };
  }
};

// ============================================================
// FUNCIONES DE UTILIDAD
// ============================================================

/**
 * Formatear template de huella para el lector FS88H
 * @param {string} rawTemplate - Template crudo del lector
 * @returns {string} Template formateado
 */
export const formatearTemplateHuella = (rawTemplate) => {
  if (!rawTemplate) return null;
  return rawTemplate.trim();
};

/**
 * Verificar si el template de huella es válido
 * @param {string} template - Template de huella
 * @returns {boolean} Válido o no
 */
export const esTemplateValido = (template) => {
  if (!template || typeof template !== 'string') return false;
  return template.length > 10 && template.startsWith('FS88H');
};

// ============================================================
// EXPORT DEFAULT
// ============================================================

export default {
  // Asistencia
  obtenerAsistenciaHoy,
  obtenerEstadisticasAsistencia,
  
  // Conexión
  obtenerEstadoLector,
  conectarLector,
  desconectarLector,
  
  // Gestión de huellas
  obtenerUsuariosConHuella,
  usuarioTieneHuella,
  registrarHuella,
  eliminarHuella,
  activarModoRegistro,
  
  // Registro de asistencia
  registrarAsistenciaManual,
  obtenerHistorialAsistencia,
  
  // Utilidades
  formatearTemplateHuella,
  esTemplateValido
};